export default "__VITE_ASSET__f328f17e__"